export enum UserSuggestionType {
  prepareForMeeting = 'UserSuggestion::PrepareForMeeting',
  goalReminder = 'UserSuggestion::GoalReminder',
  feedbackDraftReminder = 'UserSuggestion::FeedbackDraftReminder',
  provideKudos = 'UserSuggestion::ProvideKudos',
  provideFeedback = 'UserSuggestion::ProvideFeedback',
}

export type UserSuggestion = {
  type: UserSuggestionType;
  slug: string;
  title: string;
  completed: boolean;
  description: string;
  date: string;
  seenAt: string;
  clickedAt: string;
  dismissedAt: string;
  suggestablePublicId: string;
  otherUserId: number;
  otherUserPublicId: string;
  oneOnOneWorkspaceSlug: string;
};
